import { getDayForMGService } from '../../../services/DaysService'
import { getAllUsers } from '../../../services/UsersService'
import { toast } from 'react-toastify'
import { getWeekService } from '../../../services/WeeksService'

export const checkDay = async ({ yesterday, today, tomorrow }) => {
    toast.dismiss()
    if (today === undefined) {
        return
    }
    today = JSON.parse(JSON.stringify(today))

    const todayDate = new Date(today.date)
    const promises = []

    // get tomorrow day if it is not defined
    promises.push(
        tomorrow === undefined
            ? getDayForMGService(new Date(todayDate.setDate(todayDate.getDate() + 1)))
            : Promise.resolve({ data: JSON.parse(JSON.stringify(tomorrow)) })
    )
    // get yesterday day if it is not defined
    promises.push(
        yesterday === undefined
            ? getDayForMGService(new Date(todayDate.setDate(todayDate.getDate() - 2)))
            : Promise.resolve({ data: JSON.parse(JSON.stringify(yesterday)) })
    )

    //get entire week (getWeekService)
    promises.push(getWeekService(today.date))

    //get all users
    promises.push(getAllUsers())

    const [tomorrowData, yesterdayData, weekData, usersData] = await toast
        .promise(
            Promise.all(promises),
            {
                pending: 'Loading...',
                error: 'Echec de la récuperation des données',
            },
            { toastId: 'dayView.checkDay' }
        )
        .catch((e) => console.error(e))

    tomorrow = tomorrowData.data
    yesterday = yesterdayData.data
    const week = weekData.data
    const users = usersData.data

    const twoDaysOftoday = week.days.filter((day) => day.date === today.date)

    // check if all users are trained
    const sessionsWithTrainedProblems = getSessionForNotTrainedUsers(users, today)

    // check if all users are available
    const notDispoUsers = getNotDispoUsers(
        today,
        twoDaysOftoday.find((day) => !day.isReal)
    )

    // check if all users didn't work yesterday evening if they work this morning
    const usersThatWorkedYesterdayEvening = getUsersThatWorkedYesterdayEvening(
        yesterday,
        today,
        users
    )

    // check if all users will work tomorrow morning if they work this evening
    const usersThatWillWorkTomorrowMorning = getUsersThatWillWorkTomorrowMorning(
        tomorrow,
        today,
        users
    )

    // check for users that works two times in a row
    const usersThatWorkTwoTimesInARow = getUsersThatWorkTwoTimesInARow(today, users)

    //check for users that change local two times in a day
    const usersThatChangeLocalTwoTimesInADay = getUsersThatChangeLocalTwoTimesInADay(today, users)

    const toastOptions = {
        autoClose: 10000,
    }
    let isCheckDayError = false

    sessionsWithTrainedProblems.forEach(({ session, user }) => {
        isCheckDayError = true
        toast.error(
            `"${user.initials}" n'est pas formé pour la salle "${session.room.name}"`,
            toastOptions
        )
    })

    notDispoUsers.forEach(({ userId, interval }) => {
        isCheckDayError = true
        const userObj = users.find((u) => u._id === userId)
        const strDate = new Date(interval.start).toLocaleTimeString('fr-FR')
        toast.error(`"${userObj.initials}" n'est pas disponible pour "${strDate}"`, toastOptions)
    })

    usersThatWorkedYesterdayEvening.forEach((user) => {
        isCheckDayError = true
        toast.error(`"${user.initials}" est en soir/matin sur cette date`, toastOptions)
    })

    usersThatWillWorkTomorrowMorning.forEach((user) => {
        isCheckDayError = true
        toast.error(`"${user.initials}" est en soir/matin sur cette date`, toastOptions)
    })

    usersThatWorkTwoTimesInARow.forEach((user) => {
        isCheckDayError = true
        toast.error(`"${user.initials}" travaille deux fois sur un même créneau`, toastOptions)
    })

    usersThatChangeLocalTwoTimesInADay.forEach((user) => {
        isCheckDayError = true
        toast.error(`"${user.initials}" change de local deux fois dans la journée`, toastOptions)
    })

    if (!isCheckDayError) toast.success('Toutes les contraintes sont respectées !')
}

const getUsersThatChangeLocalTwoTimesInADay = (day, users) => {
    const sessions = day.intervals.flatMap((interval) => interval.sessions)
    const usersWithTheirSessions = users
        .map((user) => ({
            user,
            sessions: sessions.filter((session) => session.mg === user._id),
        }))
        .filter((user) => user.sessions.length > 2)
    const usersThatChangeLocalTwoTimesInADay = usersWithTheirSessions.filter((user) => {
        let changes = 0
        let initialValue = user.sessions[0].place_id
        user.sessions.forEach((session) => {
            if (session.place_id !== initialValue) {
                changes++
                initialValue = session.place_id
            }
        })
        return changes >= 2
    })
    return usersThatChangeLocalTwoTimesInADay.map((user) => user.user)
}

const getUsersThatWorkTwoTimesInARow = (day, users) => {
    const result = []
    day.intervals.forEach((interval) => {
        const usersIds = interval.sessions.map((session) => session.mg).filter((id) => id)
        const usersIdsThatWorkTwoTimesInARow = usersIds.filter((id) =>
            usersIds.includes(id, usersIds.indexOf(id) + 1)
        )
        if (usersIdsThatWorkTwoTimesInARow.length > 0) {
            result.push(...users.filter((user) => usersIdsThatWorkTwoTimesInARow.includes(user._id)))
        }
    })
    return result
}

const getUsersThatWorkedYesterdayEvening = (yesterday, today, users) => {
    const sessionsToday = today.intervals.sort((a, b) => a.start - b.start)[0].sessions
    const usersIdsToday = sessionsToday.map((session) => session.mg).filter((id) => id)
    const sessionsYesterday = yesterday.intervals.sort((a, b) => a.start - b.start)[7].sessions
    const usersIdsYesterday = sessionsYesterday.map((session) => session.mg).filter((id) => id)

    const usersIdsTodayThatWorkedYesterdayEvening = usersIdsToday.filter((id) =>
        usersIdsYesterday.includes(id)
    )
    return users.filter((user) => usersIdsTodayThatWorkedYesterdayEvening.includes(user._id))
}
const getUsersThatWillWorkTomorrowMorning = (tomorrow, today, users) => {
    const sessionsToday = today.intervals.sort((a, b) => a.start - b.start)[7].sessions
    const usersIdsToday = sessionsToday.map((session) => session.mg).filter((id) => id)
    const sessionsTomorrow = tomorrow.intervals.sort((a, b) => a.start - b.start)[0].sessions
    const usersIdsTomorrow = sessionsTomorrow.map((session) => session.mg).filter((id) => id)

    const usersIdsTodayThatWillWorkTomorrowMorning = usersIdsToday.filter((id) =>
        usersIdsTomorrow.includes(id)
    )
    return users.filter((user) => usersIdsTodayThatWillWorkTomorrowMorning.includes(user._id))
}

const getNotDispoUsers = (dayToWatch, prevToday) => {
    const notDispoUsers = []
    dayToWatch.intervals.forEach((interval) => {
        const prevInterval = prevToday.intervals.find(
            (prevInterval) => prevInterval.start === interval.start
        )
        const usersIds = interval.sessions.map((session) => session.mg).filter((id) => id)
        const uis = prevInterval.users_interval.filter((ui) => usersIds.includes(ui.user))
        const uisNotDispo = uis.filter((ui) => ui.available === 2)
        const ret = uisNotDispo.map((ui) => ({ userId: ui.user, interval }))
        if (uisNotDispo.length > 0) notDispoUsers.push(...ret)
    })
    return notDispoUsers
}

const getSessionForNotTrainedUsers = (users, day) => {
    const result = []
    const sessions = day.intervals
        .flatMap((interval) => interval.sessions)
        .filter((session) => session.mg !== null && session.category === 'room')

    for (let session of sessions) {
        const user = users.find((user) => user._id === session.mg)
        const theme_id = session.room.theme_id
        if (!user.theme_user.find((theme) => theme.theme_id === theme_id && theme.state >= 10)) {
            result.push({ session, user })
        }
    }
    return result
}
